import React from 'react';
import { Scrollbars } from 'react-custom-scrollbars';
import {css} from "styled-components";

export const CustomScrollBarStyle = css`
  .thumb-vertical {
    cursor: pointer;
    background-color: rgba(0, 0, 0, 25%);
    border-radius: inherit;
  }
`;

export default function ({ id, style, children, className }) {
    return (
        <Scrollbars
            id={id}
            className={className}
            style={style}
            autoHide
            autoHideTimeout={1000}
            autoHideDuration={200}
            // autoHeight
            // autoHeightMin={0}
            // autoHeightMax={1200}
            thumbMinSize={30}
            universal
            renderThumbVertical={props => <div {...props} className="thumb-vertical" />}
        >
            {children}
        </Scrollbars>
    );
}
